export const MOBILE_DEVICE_REGEX = /Android|iPhone|iPad|iPod/i
